<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template>

        <t-input v-model="form.typeEquipmentId" hidden/>

        <b-row>

          <t-input v-model="form.name" cols="9" :add-error="error.name" label="Tipo de Equipamento" required/>

          <t-input v-model="form.typePathologyCodeLabel"
                   v-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_MANUAL"
                   :add-error="error.typeEquipmentCodeLabel" upper cols="3"
                   label="Cód. Equipamento"
                   help="Código inserido manualmente conforme configurado em Produtos > Configurações > Parâmetros"
                   required/>

          <t-input v-model="form.typePathologyCodeLabel"
                   v-else-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_AUTOMATIC_DEFAULT"
                   :add-error="error.typePathologyCodeLabel" upper cols="3"
                   fixed
                   label="Cód. Equipamento"
                   help="Código inserido automaticamente conforme configurado em Produtos > Configurações > Parâmetros"
          />

        </b-row>

        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status v-model="form.status"/>

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import SectorService from "@/services/modules/agent/Sector.service";
import SettingType from "@/model/types/resource/SettingType";
import UnitType from "@/model/types/modules/general/UnitType";
export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'TypePathologyForm',
  data() {
    return {
      UnitType,
      SettingType,
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      fieldKey: "typeEquipmentId",
      form: {
        typeEquipmentId: 0,
        typePathologyNumber: 0,
        typePathologyCodeLabel: "",
        name: "",
        sectorId: "",
        color: "",
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        typeEquipmentCodeLabel: "",
        name: "",
        sectorId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modeCodeLabel: "",
      sectorOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      this.modeCodeLabel = this.getRenderRule(SettingType.render.RENDER_TAG_COD_LABEL)

      await SectorService.selectList().then((list) => {
        this.sectorOptions = list
      }).catch(error => this.responseError(error))

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  }

}
</script>

